import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import triggerCustom from '../../../javascripts/events/triggerCustom';
import BaseModule from '../../../javascripts/helpers/baseModule';
import select from '../../../javascripts/dom/select';
import removeClass from '../../../javascripts/dom/removeClass';
import addClass from '../../../javascripts/dom/addClass';

const classList = {
  error: 'form-error'
};

export default class Form extends BaseModule {
  constructor(element) {
    super(element, 'form', [{ selector: 'submit', id: 'submit' }]);
  }

  init() {
    this.formElements = select('input, select, textarea', this.elements.self);
    this.phoneInput = select('#phone-number', this.elements.self);
    this.errorMessage = select('.error-message', this.elements.self);

    // Ensure this.phoneInput is a single element
    if (Array.isArray(this.phoneInput)) {
      [this.phoneInput] = this.phoneInput;
    }

    this.initEventListeners();

    if (window.csrfTokenValue) {
      this.addHiddenInput(window.csrfTokenName, window.csrfTokenValue);
    }

    if (this.phoneInput) {
      this.intlTelInputInstance = intlTelInput(this.phoneInput, {
        initialCountry: 'de',
        strictMode: true,
        utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23.1.0/build/js/utils.js'
      });
    }
  }

  initEventListeners() {
    this.elements.submit.addEventListener('click', this.validate.bind(this));

    this.formElements.forEach((element) =>
      element.addEventListener('focusin', () => {
        removeClass(element, classList.error);
      })
    );
  }

  addHiddenInput(name, value) {
    const input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', name);
    input.setAttribute('value', value);
    this.elements.self.appendChild(input);
  }

  validate(event, cb) {
    if (event) {
      event.preventDefault();
    }

    let isValid = this.formElements.reduce((acc, element) => {
      const valid = element.validity.valid || element.disabled;
      const formField = element.closest('.form__field');

      if (formField) {
        if (valid) {
          removeClass(formField, classList.error);
        } else {
          addClass(formField, classList.error);
        }
      }
      return valid && acc;
    }, true);

    if (this.phoneInput) {
      const isPhoneValid = this.intlTelInputInstance.isValidNumber();
      const phoneField = this.phoneInput.closest('.form__field');
      const [errorMessage] = this.errorMessage;

      if (phoneField) {
        if (isPhoneValid) {
          removeClass(phoneField, classList.error);
          if (errorMessage) {
            errorMessage.style.opacity = '0'; // Verstecke die Fehlermeldung
          }
        } else {
          addClass(phoneField, classList.error);
          if (errorMessage) {
            errorMessage.style.opacity = '1'; // Zeige die Fehlermeldung an
          }
        }
      }
      isValid = isValid && isPhoneValid;
    }

    if (cb) {
      cb(isValid);
    } else if (isValid) {
      triggerCustom(this.elements.self, 'success', event);

      // add phone number as hidden input
      if (this.phoneInput) {
        this.addHiddenInput('phone_full', this.intlTelInputInstance.getNumber());
      }
      this.elements.self.submit();
    }
  }
}
